module.exports = __webpack_public_path__ + "img/qxl-office.c6c3f3b2.png";